import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-managearticle',
  templateUrl: './managearticle.component.html',
  styleUrls: ['./managearticle.component.css']
})
export class ManagearticleComponent implements OnInit {
  getarticlelistRestApiUrl:string = AppSettings.articlelist;
  DeletearticleRestApiUrl:string = AppSettings.deletearticle;
  getpackageinfodetApiUrl:string = AppSettings.getPackageInfo; 
  getarticlebywebsiteApiUrl:string= AppSettings.articlelistbyweb;

  article_det:Array<Object>;
  categoryDet:Array<Object>;
  packagelist:Array<Object>;
  websitelist:Array<Object>;
  model:any={};
  articlemodel:any={};
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router) { }

  ngOnInit() {
    this.loginService.localStorageData();
    this.loginService.viewsActivate();
    let user_id = localStorage.getItem('currentUserID');
    this.websitelist=[];
     this.CommonService.editdata(this.getpackageinfodetApiUrl,user_id)
          .subscribe(resultdata =>{   
            this.packagelist=resultdata.result;
            this.packagelist.filter((resultexpgem:any) =>{
              this.websitelist.push(resultexpgem.website);

            });
             
            this.articlemodel.weblist = this.websitelist;
            this.model.usergroup=localStorage.getItem('currentUsergroup');
              if(this.model.usergroup==2)
              {
                this.articlemodel.userid = user_id;
                this.CommonService.insertdata(this.getarticlebywebsiteApiUrl,this.articlemodel)
                  .subscribe(resultdata =>{
                   if(resultdata.result!=""){
                     this.article_det=resultdata.result;

                     this.categoryDet=resultdata.category_name;
                     this.loginService.viewCommontdataTable('dataTable','productinfo_table');
                     //this.loginService.viewCommontdataTable('dataTable','productinfo_table');
                  }
                });
              }
              else{
                this.CommonService.getdata(this.getarticlelistRestApiUrl)
                .subscribe(det =>{
                    if(det.result!=""){
                      this.article_det=det.result;
                      this.loginService.viewCommontdataTable('dataTable','productinfo_table');
                      //this.loginService.viewCommontdataTable('dataTable','productinfo_table');
                    }
                });
              }
             // this.loginService.viewCommontdataTable('dataTable','productinfo_table');
      });
      
       
    
            

  }

  navigateAddarticle()
  {
    this.router.navigate(['/addarticle']);
  }
  editarticle(id:any)
  {
     this.router.navigate(['/editarticle',id]);
  }
  deletearticle(id:any)
  {
    let idx = id;
      let self = this;
      swal({
        title: 'Are you sure?',
         buttons: {
            cancel: true,
            confirm: true,
          },
        text: "You won't be able to revert this!",
      }).then(function (result) {
        if(result)
        {
           self.removeproduct(idx);
          swal(
            'Deleted!',
            'Article Data has been deleted.',
            'success'
          )
        }
      },function(dismiss) {
    });
  }
 removeproduct(idx:any)
 {
   this.CommonService.deletedata(this.DeletearticleRestApiUrl,idx)
        .subscribe(resultdata =>{
        //  this.CommonService.getdata(this.getarticlelistRestApiUrl)
        // .subscribe(det =>{
        //     if(det.result!=""){ this.product_det=det.result;}
        // });
        this.ngOnInit();
      });
 }

}
